import Skeleton, { SkeletonProps } from "react-loading-skeleton";
import "./skeleton.css";
import styles from "./skeleton.module.scss";

export const SkeletonBase = ({
  position,
  ...props
}: SkeletonProps & { position?: "relative" | "absolute" }) => {
  return (
    <span
      className={`${styles["skeleton"]} sharedui-skeleton ${props.className ? props.className : ""}`}
      style={{
        position: position ? position : "relative",
        width: position?.includes("absolute") ? "100%" : "",
        height: position?.includes("absolute") ? "100%" : "",
        top: position?.includes("absolute") ? "0" : "",
        left: position?.includes("absolute") ? "0" : "",
      }}
    >
      <Skeleton {...props} />
    </span>
  );
};
